import * as React from 'react';

import { Button } from '@coursera/cds-core';

import { useEoiEventing } from 'bundles/expression-of-interest/utils/eventingUtils';
import TrackedButton from 'bundles/page/components/TrackedButton';
import LoadingIcon from 'bundles/xddp/components/shared/LoadingIcon';

import _t from 'i18n!nls/xddp';

import 'css!bundles/xddp/components/__styles__/eoi/EoiAction';

type Props = {
  onNextClick: () => void;
  isTerminalSection: boolean;
  isSubmitting: boolean;
  message: string;
  trackingProductId: string;
};

const EoiAction = ({ onNextClick, isTerminalSection, isSubmitting, message, trackingProductId }: Props) => {
  const { trackSubmitEoi } = useEoiEventing(trackingProductId);

  if (isTerminalSection) {
    return null;
  }

  const handleOnClick = () => {
    onNextClick();
    trackSubmitEoi('success', 'single_section_eoi');
  };

  const label = message || _t('Next');
  return (
    <Button
      variant="secondary"
      trackingName="eoi_request_info"
      className="rc-EoiAction m-x-auto"
      component={TrackedButton}
      withVisibilityTracking={true}
      requireFullyVisible={true}
      onClick={handleOnClick}
      disabled={isSubmitting}
      icon={isSubmitting ? <LoadingIcon size="medium" className="rc-EoiLoader" /> : undefined}
    >
      {isSubmitting ? undefined : label}
    </Button>
  );
};

export default EoiAction;
